<template>
  <div id="login">
    <el-container style="height: 100%;">
      <el-header style="background-color: #409EFF">
        <el-row style="line-height: 60px; color:#FFF">
          <el-col :span="16"><span class="el-icon-menu"></span> 小度订单助手</el-col>
          <el-col :span="1"><el-link style="color:#FFF;font-size: 12pt; text-decoration:none;"  target="_blank" href="http://fw.jd.com/227402.html">订购</el-link></el-col>
          <el-col :span="6" >
            <div v-if="logined" ><span class="el-icon-user-solid"></span>【meyau】
              <el-link style="color:#FFF;font-size: 12pt;text-decoration:none;"  @click="logout">注销</el-link>&#8194;&#8194;剩余365天
            </div>
            <div v-else="logined" class="login">
              <el-link style="color:#FFF;font-size: 12pt; text-decoration:none;" href="https://auth.1688.com/oauth/authorize?client_id=7317636&site=1688&redirect_uri=https://alibaba.zdinfo.top/%23/&state=trade">请登录</el-link></div>

          </el-col>
          <el-col :span="1">
            <div>
              <a target="_blank" href="http://wpa.qq.com/msgrd?v=3&uin=275035053&site=qq&menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:275035053:41" alt="点击这里给我发消息" title="点击这里给我发消息"></a>
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-container >
        <el-aside width="200px"  style="height: 100%;">
          <el-menu
            @select="handleSelect"
            @open="handleOpen"
            :default-active="active"
            class="el-menu-vertical-demo1"
            style="font-size: 20px;height: 100%;"
          >
            <el-menu-item index="1">
              <i class="el-icon-s-home"></i>
              <span slot="title">首 页</span>
            </el-menu-item>
            <el-menu-item index="2">
              <i class="el-icon-tickets"></i>
              <span slot="title">同步订单</span>
            </el-menu-item>
            <el-menu-item index="3">
              <i class="el-icon-tickets"></i>
              <span slot="title">显示数据</span>
            </el-menu-item>
            <el-menu-item index="4">
              <i class="el-icon-tickets"></i>
              <span slot="title">批量发货</span>
            </el-menu-item>
            <el-menu-item index="5">
              <i class="el-icon-tickets"></i>
              <span slot="title">批量备注</span>
            </el-menu-item>
            <el-menu-item index="6">
              <i class="el-icon-tickets"></i>
              <span slot="title">延长收货</span>
            </el-menu-item>
            <el-menu-item index="7">
              <i class="el-icon-tickets"></i>
              <span slot="title">配货统计</span>
            </el-menu-item>
            <el-menu-item index="8">
              <i class="el-icon-tickets"></i>
              <span slot="title">商品管理</span>
            </el-menu-item>
            <el-menu-item index="9">
              <i class="el-icon-tickets"></i>
              <span slot="title">定制功能</span>
            </el-menu-item>
            <el-menu-item index="10">
              <i class="el-icon-tickets"></i>
              <span slot="title">权限管理</span>
            </el-menu-item>


          </el-menu>
        </el-aside>
        <el-main>

          <h2 style="color: #dd6161"></h2>
          <h3>软件说明</h3>
          <h4>一、关于升级</h4>
          <p style="font-weight: bold;color: #3a8ee6">1、软件使用中遇到问题，请点右上角【联系客服】。</p>
          <p style="font-weight: bold;color: #3a8ee6">2、升级后，同步订单和显示数据不在同一页显示，同步订单后，请点【显示数据】。</p>
          <p style="font-weight: bold;color: #3a8ee6">3、老版本的保存的显示列，在【同步订单】页面点【从服务器下载】，下载显示顺序。</p>
          <p style="font-weight: bold;color: #3a8ee6">4、要调整显示列的显示顺序，在【同步订单】页面点【调整顺序】。</p>
          <p style="font-weight: bold;color: #3a8ee6">5、对软件有其他功能需求，请联系客服进行 【定制功能】。</p>
          <p><el-button v-show="false" type="primary" @click="test">模拟登录</el-button></p>

          <router-view v-wechat-title='$route.meta.title'></router-view>

          <div align="center" style="margin-top: 100px">
              <span style="font-size: 12px">Copyright ©2020 ZDINFO.TOP 版权所有
                <el-link href="http://www.beian.miit.gov.cn"  type="primary" style="margin-left: 10px;font-size: 12px">豫ICP备17046731号</el-link></span>
          </div>

        </el-main>
      </el-container>

    </el-container>


  </div>
</template>

<script>
    import storage from "../api/storage";
    import cookies from "../api/cookie";
    import $api from "../api/axios";

    export default {
      name: "Login",
      data(){
        return {
          logined: false,
          code:""
        }
      },
      methods:{
        handleSelect: function (index) {
          this.$message({
            type: 'error',
            message: '您当前没有登录，请登录后进行操作！'
          });
        },
        getUrl:function (name) {
          return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null

        },
        login:function(){
          let param = {
            code: this.code,
          }
          $api.post("/oauth", param, response =>{
            let dataResult = response.data;
            console.log(dataResult);
            if (dataResult.state == 1 && dataResult.message == "ok") {
              storage.set("nick", dataResult.data.nick);
              storage.set("venderId", dataResult.data.venderId);
              storage.set("days",dataResult.data.days);
              storage.set("token", dataResult.data.token);
              //新登录 清除上次保存的时间
              storage.remove("created");
              console.log(dataResult.data.days);
              this.$router.replace({name: 'Main'});
            }else{
              this.$message({
                type: 'error',
                message: '抱歉，登录失败'+dataResult.message
              })
            }
          });
        },
        test:function () {
          let param = {
            /*nick:"alitestforisv02",
            venderId:"",
            sessionkey:"53eacb4a-21e5-4f92-9811-985bd7e2caa0"*/
            nick:'锦恒电子商务',
            sessionkey:'01857739-af74-498e-8d09-6da21b3ee415',
            venderId:'',
          }
          $api.post("/login", param, response => {
            let dataResult = response.data;
            if(dataResult.state == 1){
              storage.set("nick", dataResult.data.nick);
              storage.set("venderId", dataResult.data.venderId);
              storage.set("days", 97);
              storage.set("token", dataResult.data.token);
              this.$router.replace({name: 'Main'});

            }
          })
        }
      },
      mounted() {
        //storage.remove("venderId");
        this.code = this.getUrl("code");
        console.log(this.code);
        if(this.code != null){
          this.login();
        }else {
          let nick = storage.get("nick");
          if (nick != null) {
            this.$router.replace({name: "Index"});
          }
        }

      },
    }
</script>

<style >
  #login {
    font-family: ‘宋体’,'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: left;
    color: #2c3e50;
    height: 100%;
  }

  .el-link.el-link--default {
    color: #FFF;
  }

</style>



// WEBPACK FOOTER //
// src/page/Login.vue